<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <image-file-input-viewer
            label="Podcast Thumbnail"
            v-model="form.thumbnail"
          />

          <v-text-field
            class="mt-4"
            v-model="form.title"
            outlined
            label="Title"
            :error-messages="form.$getError('title')"
          />

          <v-textarea
            class="mt-4"
            v-model="form.description"
            outlined
            label="Description"
            :error-messages="form.$getError('description')"
          />

          <v-text-field
            v-model="form.btn_text"
            outlined
            label="Button Text"
            :error-messages="form.$getError('btn_text')"
          />
          <v-switch
            v-model="linkToArticle"
            label="Article"
          />

          <v-text-field
            v-show="!linkToArticle"
            v-model="form.btn_url"
            outlined
            label="URL"
            :error-messages="form.$getError('btn_url')"
          />

          <article-select
            v-show="linkToArticle"
            v-bind:articleId.sync="form.article_id"
            :articleTitle="article_title"
          />

        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import PodcastItem from '@/models/PodcastItem'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ArticleSelect from '@/components/ArticleSelect'

const initialData = {
  title: null,
  description: null,
  btn_url: null,
  btn_text: null,
  thumbnail: null,
  article_id: null
}

export default {

  components: {
    AppBarNavIcon,
    ImageFileInputViewer,
    ArticleSelect

  },

  data () {
    return {
      linkToArticle: false,
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      article_title: null,
      loadingTags: false,
      form: new Form({
        ...initialData
      })
    }
  },
  props: {
    podcastItem: {
      type: [PodcastItem, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Podcast Item'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'podcast-items'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'podcast-items'
        }
      }
    }
  },

  methods: {
    head,
    replace,
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()
        this.$delete(data, 'tag_id')

        if (data.article) this.$delete(data, 'article')

        this.linkToArticle ? data.btn_url = null : data.article_id = null

        if (this.isModeUpdate) {
          data._method = 'put'

          if (data.thumbnail && data.thumbnail.id) { this.$delete(data, 'thumbnail') }
        }

        const podcastItem = new PodcastItem(data)
        await podcastItem.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }

  },

  watch: {
    podcastItem: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })

          if (val.article) {
            this.linkToArticle = true
            this.form.article_id = val.article.id
            this.article_title = val.article.title
          }
        }
      }
    }
  },

  computed: {
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    }
  }
}
</script>
